/** `2026-03` → `2026年3月`. */
export function formatMonth(month: string): string {
  const [year, value] = month.split('-');
  return `${year}年${Number(value)}月`;
}
